export default __webpack_public_path__ + "static/media/testmaker@3x.0b49a0bb.png";